import { TrackingEventType } from '../constants/tracking-event-type.ts';
import { TrackingEventEnum } from '../constants/tracking-event.ts';

export const mapTrackingEventToAnalyticsType = (event: TrackingEventEnum): TrackingEventType[] => {
  switch (event) {
    case TrackingEventEnum.FIRST_LESSON_COMPLETED:
      return [TrackingEventType.MARKETING];

    case TrackingEventEnum.FIRST_APP_OPEN:
    case TrackingEventEnum.PARENT_INFO_SUBMITTED:
    case TrackingEventEnum.PARENT_SIGN_UP:
    case TrackingEventEnum.PARENT_SIGN_IN:
    case TrackingEventEnum.CHILD_PROFILE_CREATED:
      return [TrackingEventType.ANALYTICS, TrackingEventType.MARKETING];

    default:
      return [TrackingEventType.ANALYTICS];
  }
};
